import { Box, Flex, Text, Tooltip, VStack } from '@chakra-ui/react'

import getSeriesStreakStatusConfig from '@/components/Series/SeriesStreakBar/internal/getSeriesStreakStatusConfig'

export default function SeriesStreakStatus({
  hasUpcomingSessions,
  currentStreak,
  longestStreak,
}: {
  hasUpcomingSessions: boolean
  currentStreak: number
  longestStreak: number
}) {
  const showFireIcon = currentStreak >= 2

  const { primaryText, secondaryText, iconComponent } = getSeriesStreakStatusConfig({
    hasUpcomingSessions,
    currentStreak,
    longestStreak,
  })

  return (
    <Box width={{ base: '100%', md: '30%' }} ml={{ md: '16px' }} mt={{ base: '16px', md: '10px' }}>
      <Tooltip
        label="A streak counts how many sessions you've attended in a row"
        placement="top"
        hasArrow
      >
        <Flex alignItems="center" justifyContent={{ base: 'center', md: 'flex-start' }}>
          <Box
            mr="12px"
            color={showFireIcon ? 'yellow.solid' : 'gray.focusRing'}
            fontSize="42px"
            display="flex"
            alignItems="center"
            height="42px"
            position="relative"
          >
            {iconComponent}
          </Box>
          <VStack spacing="0" alignItems="flex-start" justifyContent="center">
            <Text fontWeight="bold" fontSize="16px" lineHeight="1.2">
              {primaryText}
            </Text>
            {secondaryText != null ? (
              <Text fontSize="14px" color="fg.muted" lineHeight="1.2">
                {secondaryText}
              </Text>
            ) : null}
          </VStack>
        </Flex>
      </Tooltip>
    </Box>
  )
}
